module.exports = __webpack_public_path__ + "media/images/eraser-f85ba380.png";